// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { DealDocuments, DocumentStatus } from '@interfaces/document.interfaces';
import { DocumentsService } from '@services/documents.service';
import { Observable, map, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DealDocResolver implements Resolve<DealDocuments> {
    constructor(private documentService: DocumentsService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<DealDocuments> {
        // route param is coming over as string
        const dealId: number = parseInt(route.params.dealId);
        // Last check is making sure we always refresh when we hit the
        // deal/jacket page directly
        if (this.documentService.documents && dealId === this.documentService.dealId && route.url.length > 0) {
            const docs = this.documentService.documents;
            return of({
                complete: docs.filter((doc) => doc.documentStatusId === DocumentStatus.Complete),
                buyer: docs.filter((doc) => doc.documentStatusId === DocumentStatus.BuyerQueue),
                cobuyer: docs.filter((doc) => doc.documentStatusId === DocumentStatus.CoBuyerQueue),
                dealer: docs.filter((doc) => doc.documentStatusId === DocumentStatus.DealerQueue),
                signingCertInProcess: docs.filter((doc) => doc.documentStatusId === DocumentStatus.EnqueueCertification),
                interventionRequired: docs.filter((doc) => doc.documentStatusId === DocumentStatus.InterventionRequired),
                deleted: docs.filter((doc) => doc.documentStatusId === DocumentStatus.Deleted),
                notarizeQueue: docs.filter((doc) => doc.documentStatusId === DocumentStatus.NotarizeQueue),
            });
        } else {
            return this.documentService.getDocsList$(dealId).pipe(
                map((docs) => {
                    return {
                        complete: docs.filter((doc) => doc.documentStatusId === DocumentStatus.Complete),
                        buyer: docs.filter((doc) => doc.documentStatusId === DocumentStatus.BuyerQueue),
                        cobuyer: docs.filter((doc) => doc.documentStatusId === DocumentStatus.CoBuyerQueue),
                        dealer: docs.filter((doc) => doc.documentStatusId === DocumentStatus.DealerQueue),
                        signingCertInProcess: docs.filter((doc) => doc.documentStatusId === DocumentStatus.EnqueueCertification),
                        interventionRequired: docs.filter((doc) => doc.documentStatusId === DocumentStatus.InterventionRequired),
                        deleted: docs.filter((doc) => doc.documentStatusId === DocumentStatus.Deleted),
                        notarizeQueue: docs.filter((doc) => doc.documentStatusId === DocumentStatus.NotarizeQueue),
                    };
                })
            );
        }
    }
}
